// @flow

import BaseExtension from './base';

import BaseController from '../players/base';
import StateEntity from '../state';

import { createElement, toggleClass } from '../utils';

import popover from './helpers/popover';
import createSvg, { THEATER_MODE, EXIT_THEATER_MODE } from '../svgs';

import type { Player$ExtensionOptions } from '../types/Options';
import type { Player$State } from '../types/State';

const CN = 'rmp-ext-theater';
const EXIT_CN = `${CN}--exit`;
const HIDDEN_CN = `${CN}--hidden`;

export default class TheaterExtensions extends BaseExtension {
   $el: HTMLElement

   constructor(player: BaseController, state: StateEntity, options: Player$ExtensionOptions) {
      super(player, state, options, ['statechanged']);
      this.logger.debug('theater:extension:creating');

      this.render();
      this.addEvent(this.$el, 'click', this.toggle.bind(this));
      toggleClass(this.$el, EXIT_CN, state.isTheaterMode());

      this.logger.debug('theater:extension:created');
   }

   render() {
      this.$el = createElement('button', { type: 'button', class: CN });

      createSvg(this.$el, THEATER_MODE, { class: `${CN}__icon`});
      createSvg(this.$el, EXIT_THEATER_MODE, { class: `${CN}__exit-icon`});

      const text = () => this.$t(this.state.isTheaterMode() ? 'exit-theater' : 'theater');
      setTimeout(() => popover(this, { $button: this.$el, text }) );
   }

   toggle() {
      this.bus.emit('theaterchanging');
   }

   onStatechanged(state: Player$State) {
      toggleClass(this.$el, EXIT_CN, state.isTheaterMode);
      toggleClass(this.$el, HIDDEN_CN, state.isFullScreen);
   }

   getElement() {
      return this.$el;
   }
}
